import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceEditProjectReportTemplateNotificationState = createStateReducer(
  initialState,
  {
    [events.editProjectReportTemplateSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editProjectReportTemplate",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.editProjectReportTemplateFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editProjectReportTemplate",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceEditProjectReportTemplateNotificationState };
